import { Collection } from 'modules/core/lib/mobx-rest'

import PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'

export class PaymentItems extends Collection<PaymentItem> {
  get cacheKey(): string {
    return 'paymentItems'
  }

  get indexes() {
    return ['payment_id', 'employee_id']
  }

  model() {
    return PaymentItem
  }

  paymentItemsByPaymentIds(paymentIds: string[]): PaymentItem[] {
    return paymentIds.flatMap((paymentId) => {
      return this.filter({ payment_id: paymentId })
    })
  }

  paymentItemByPaymentId(paymentId: string): PaymentItem[] {
    return this.models.filter((paymentItem) => paymentItem.attributes.payment_id === paymentId)
  }
}

export default new PaymentItems()
